import { TaskInvoicingFrequencies, Week } from './../task.constants';
import { Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TaskStatuses } from '../task.constants';
import * as _ from 'lodash';
import { ITask } from '../task.interface';
import { TaskHttpService } from '../task-http.service';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { forkJoin, lastValueFrom, Observable, of, Subscription } from 'rxjs';
import { TaskCommentComponent } from '../task-comment/task-comment.component';
import { TaskCommentService } from '../task-comment/task-comment.service';
import { ITaskComment } from '../task-comment/task-comment.interface';
import { TaskMovementsComponent } from '../task-movements/task-movements.component';
import { TaskShareComponent } from '../task-share/task-share.component';
import { MatSelect } from '@angular/material/select';
import { Frequency, Options, RRule } from 'rrule';
import { Router } from '@angular/router';
import { TaskModalComponent } from '../task-modal/task-modal.component';
import { TaskService } from '../task.service';
import { NextAppointmentModalComponent } from '../next-appointment-modal/next-appointment-modal.component';
import { ICategory } from '../../../categories-page/categories/categories.interface';
import { IWorker } from '../../../workers-page/workers/workers.interface';
import { IAppointment } from '../appoinment/appointment.interface';
import { IDetailItem, getEmptyDetailItem } from '../../../../shared/components/detail-item/detail-item.interface';
import { ITimeTrack, ITimeTrackFilter } from '../../../time-tracks-page/time-track/time-track.interface';
import { IBillingDocument, IBillingDocumentTypes } from '../../../billing-documents-page/billing-documents/billing-documents.interface';
import { InvoiceStatuses } from '../../../billing-documents-page/billing-documents/billing-documents.constants';
import { IExpense, getEmptyDetailItemExpense } from '../../../expenses-page/expenses/expenses.interface';
import { UserService } from '../../../users-page/users/users.service';
import { TimeTrackService } from '../../../time-tracks-page/time-track/time-track.service';
import { ServiceAgreementHttpService } from '../../../service-agreements-page/service-agreements/service-agreements.service';
import { CategoriesService } from '../../../categories-page/categories/categories.service';
import { ClientsService } from '../../../clients-page/clients/clients.service';
import { ProductsService } from '../../../products-page/products/products.service';
import { WorkersService } from '../../../workers-page/workers/workers.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { AppointmentsService } from '../appoinment/appointment.service';
import { BillingDocumentService } from '../../../billing-documents-page/billing-documents/billing-documents.service';
import { AlertService } from '../../../../shared/services/alert.service';
import { SettingsService } from '../../../settings-page/settings/settings.service';
import { DeliveryNotesService } from '../../../delivery-notes-page/delivery-notes/delivery-notes.service';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { SETTINGS } from '../../../settings-page/settings/settings.constants';
import { IConfirmationDialogOptions } from '../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { toNativeDate } from '../../../../shared/components/recurrence/recurrence.component';
import { IServiceAgreement } from '../../../service-agreements-page/service-agreements/service-agreements.interface';
import { ICustomDialogOptions } from '../../../../shared/services/dialog/custom-dialog/custom-dialog-options.interface';
import { IInformationDialogOptions } from '../../../../shared/services/dialog/information-dialog/information-dialog-options.interface';
import { DeliveryNotesPDFModalComponent } from '../../../delivery-notes-page/delivery-notes/delivery-notes-pdf-modal/delivery-notes-pdf-modal.component';
import { BillingDocumentsModalComponent } from '../../../billing-documents-page/billing-documents/billing-documents-modal/billing-documents-modal.component';
import { BillingDocumentsPDFModalComponent } from '../../../billing-documents-page/billing-documents/billing-documents-pdf-modal/billing-documents-pdf-modal.component';
import { FileViewModalComponent } from '../../../../shared/components/file-view-modal/file-view-modal.component';
import { IFile } from '../../../../shared/components/files/file.interface';
import { ExternalRequestModalComponent } from '../../../../shared/components/external-request/external-request-modal/external-request-modal.component';

let self: any;

@Component({
  selector: 'app-task-single',
  templateUrl: './task-single.component.html',
  styleUrls: ['./task-single.component.css']
})
export class TaskSingleComponent implements OnInit {
  private statusInput!: MatSelect;
  @ViewChild('statusInput', { static: false }) set input(input: MatSelect) {
    if (input) this.statusInput = input;
  };
  @ViewChild('bottom', { static: false }) bottomElement!: ElementRef;
  @ViewChild('top', { static: false }) topElement!: ElementRef;

  action: string = '';
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  showStart: boolean = true;
  showEnd: boolean = true;
  showEdit: boolean = true;
  loading: boolean = false;
  task!: ITask;
  newStatus!: string;
  comments: any = [];
  form!: UntypedFormGroup;
  formValueChanged: boolean = false;
  saving: boolean = false;
  submitted = false;
  lastDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
  taskInvoicingFrequencies = TaskInvoicingFrequencies;
  taskInvoicingFrequenciesKeys = Object.keys(TaskInvoicingFrequencies);
  taskStatuses: any = TaskStatuses;
  taskStatusesKeys = Object.keys(TaskStatuses);
  taskStatusColors: any = {};
  status!: string;
  // statusEditable: boolean = true;
  categories: ICategory[] = [];
  $clients: Observable<any> = of();
  workers: IWorker[] = [];
  $products: Observable<any> = of();
  // productItems: ITaskProduct[] = [];
  isDev!: boolean;
  curr!: string;
  subscriptions: Subscription;
  appoinment!: IAppointment;
  cost: number = 0;
  subtotal: number = 0;
  tax: number = 0;
  taxPercentage: number = 0;
  total: number = 0;
  notEditableAlert: boolean = false;
  scheduling: boolean = false;
  recurringTask: boolean = false;
  frequency = Frequency;
  week = Week;

  recurrence: any;

  scrollToComments = false;
  emptyItem = getEmptyDetailItem();

  // recurringWDays = [false, false, false, false, false, false, false];
  private weekdayMap = [
    RRule.SU,
    RRule.MO,
    RRule.TU,
    RRule.WE,
    RRule.TH,
    RRule.FR,
    RRule.SA,
  ];
  filterTimeTrack!: ITimeTrackFilter;
  timeTracks!: ITimeTrack[];
  filteredWorkers: IWorker[] = [];

  rruleSchedule!: string;
  haveRecurrence: { recurrenceRule?: string } = {};
  recuFreq!: string;
  recuDay!: string;
  recuCount!: string;
  recuWeek!: string[];
  startDate!: string;
  startDateTime!: string;
  dateRange!: string;
  untilDate!: string;
  recuInterval!: string;

  invoice!: IBillingDocument;
  invoiceStatuses = InvoiceStatuses;
  agreementInvoicing!: boolean;

  constructedForm: boolean = false;
  refreshPage: boolean = false;

  emptyItemaa = getEmptyDetailItemExpense();

  constructor(
    public _TaskHttpService: TaskHttpService,
    public _TaskCommentService: TaskCommentService,
    public _UserService: UserService,
    public _TimeTrackService: TimeTrackService,
    public _ServiceAgreementHttpService: ServiceAgreementHttpService,
    public _CategoriesService: CategoriesService,
    public _ClientsService: ClientsService,
    public _ProductsService: ProductsService,
    public _WorkersService: WorkersService,
    public dialogRef: MatDialogRef<any>,
    public commentDialogRef: MatDialogRef<any>,
    public movementsDialogRef: MatDialogRef<any>,
    private _dialogService: DialogService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private fb: UntypedFormBuilder,
    private _AuthService: AuthService,
    private _UtilsService: UtilsService,
    public _AppointmentsService: AppointmentsService,
    // public _ScheduleService: SchedulesService,
    private _BillingDocumentService: BillingDocumentService,
    private _AlertService: AlertService,
    private _SettingsService: SettingsService,
    private _DeliveryNotesService: DeliveryNotesService,
    private _router: Router,
    private _TaskService: TaskService,
    private _broadcaster: Broadcaster,
  ) {
    self = this;
    this.dialog = dialogRef;
    this.subscriptions = new Subscription();
  }

  async ngOnInit() {
    console.log(this.task)

    this.filterTimeTrack = {
      company: this._AuthService.companyId(),
      skip: 0,
      limit: 10000,
      filters: {}
    };

    this.getStatusColors();
    this.curr = this._AuthService.currency();
    this.isDev = this._AuthService.isRole('dev');

    if (!Array.isArray(this.task?.products) || this.task?.products.length === 0) {
      this.task.products = [getEmptyDetailItem()];
    }

    if (this.task._id) {
      this.action = 'Modificar'
      await this.initializeComponent(this.newStatus);
      //await this.getTask(this.newStatus);

      // REFACTOR: Has to wait for the form to be built for the first time
      setTimeout(() => {
        this.constructedForm = true;
      }, 2000);
      // REFACTOR

    }
    else {
      if (this.task.status == 'QUOTED' && this.scheduling) {
        this.action = 'Programar';
        this.task.status = 'SCHEDULED';
      }
      else if (this.task.client) {  //  revisar ????
        this.action = 'Duplicar';
        const rule = (this.task.appointment?.schedule as any)?.recurrenceRule;
        if (rule) {
          this.recurrence = { rule };
          this.recurrence.recurringFrequency = this.frequency[getValue('FREQ', rule)];
          //console.log(rule);
        }
      }
      else {
        this.action = 'Crear';
      }
      await this.buildForm();
      this.constructedForm = true;
    }

    // disable click outside modal
    self.dialogRef.disableClose = true;
    self.dialogRef.backdropClick().subscribe(() => {
      this.closeModal()
    });
  }

  async initializeComponent(newStatus?: string) {
    this.loading = true;
    this.productsChanged = false;
    this.recurringTask = false;
    this.scheduling = newStatus === 'SCHEDULED';
    this.comments = null;
    console.log(this.task)


    const sub = forkJoin({
      document: this._TaskService.getBillingDocument(this.task),
      task: this._TaskHttpService.getTask(this.task._id || ''),
      appointment: this._TaskService.getAppointments(this.task._id),
      comments: this._TaskService.getComments(this.task._id),
    }).subscribe(async data => {

      // Billing doc
      if (data.document && data.document.status !== this.invoiceStatuses.CANCELLED && !data.document.isDeleted) {
        this.invoice = data.document as any;
      }

      // Task
      this.task = data.task;
      console.log(this.task)
      if (!((this.task.products as any).length > 0)) {
        this.task.products = [getEmptyDetailItem()];
      }
      if (this.task?.workers) {
        this.filteredWorkers = data.task.workers.filter((worker: any) => !worker.isDeleted);
      }

      // Appointment
      this.appoinment = data.appointment;
      this.haveRecurrence = (this.appoinment.schedule) as { recurrenceRule?: any };
      this.formatRecurrence(this.haveRecurrence);

      // Comments
      this.comments = data.comments;

      if ((this.task?.workers as any).length > 0) {
        const sub2 = forkJoin({
          timeTracks: this._TaskService.getTimeTracks(this.task),
        }).subscribe(async moreData => {
          // Time track
          this.timeTracks = moreData.timeTracks as ITimeTrack[];

          await this.buildForm();
          this.constructedForm = true;
          this.loading = false;

          sub2.unsubscribe();
        });
      } else {
        this.buildForm();
        this.constructedForm = true;
        this.loading = false;
      }
      sub.unsubscribe();
    });

    // Disable click outside modal
    self.dialogRef.disableClose = true;
    self.dialogRef.backdropClick().subscribe(() => {
      this.closeModal();
    });

    // REFACTOR: Has to wait for the form to be built for the first time
    setTimeout(() => {
      this.constructedForm = true;
    }, 4000);
  }

  async getTask(newStatus?: string) {
    this.initializeComponent(newStatus)
  }

  async getStatusColors() {
    this.taskStatusColors = { DEFAULT: 'white', SCHEDULED: '#337AB7', INVOICED: '#FF9E00' };
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_OPEN_COLOR)
      .then((color) => { this.taskStatusColors.OPEN = color; this.taskStatusColors.QUOTED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_ONGOING_COLOR)
      .then((color) => { this.taskStatusColors.ONGOING = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_COMPLETED_COLOR)
      .then((color) => { this.taskStatusColors.COMPLETED = color });
    this._SettingsService.getCompanySettingValue(SETTINGS.SCH_TASK_CANCELLED_COLOR)
      .then((color) => { this.taskStatusColors.CANCELLED = color });
  }

  scrollDialogToTop() {
    if (this.topElement && this.topElement.nativeElement) {
      this.topElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  scrollDialogToComments() {
    if (this.bottomElement && this.bottomElement.nativeElement) {
      this.bottomElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  setStatusCompleted() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Completar trabajo",
      message: "¿Desea cambiar este trabajo a estado Completado?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef).subscribe((confirmation: any) => {
      if (confirmation) {
        //this.setStatus('COMPLETED');
        //this.setStatus('COMPLETED');
        this.f['status'].setValue('COMPLETED')
        this.task.status = this.f['status'].value;
        this.onSubmit('COMPLETED');
        this.getTask('COMPLETED')
      }
    });
  }

  getComments() {
    this._TaskCommentService.getComments({
      task: this.task._id,
      // filters: { task: this.task._id },
      company: this._AuthService.companyId()
    }).subscribe(async comments => {
      this.comments = comments;

      if (this.scrollToComments) {
        setTimeout(() => {
          this.scrollDialogToComments();
        }, 100);
      }
      this.scrollToComments = false;
    })
  }

  get detailItems(): IDetailItem[] {
    return (this.task?.products as IDetailItem[]);
  }

  get safeExpenses(): IExpense[] {
    return (this.task?.expenses as IExpense[]);
  }


  /*----------------- Format ------------------*/
  formatRecurrence(haveRecurrence: any) {

    if (haveRecurrence) {
      const freqMatch = haveRecurrence.recurrenceRule ? haveRecurrence.recurrenceRule.match(/FREQ=([^;]*)/) : null;
      this.recuFreq = freqMatch ? this.formatFreq(freqMatch[1]) : '';

      const recuIntervalMatch = haveRecurrence.recurrenceRule.match(/INTERVAL=(\d+)/);
      this.recuInterval = recuIntervalMatch ? recuIntervalMatch[1] : '';

      const recuCountMatch = haveRecurrence.recurrenceRule.match(/COUNT=(\d+)/);
      this.recuCount = recuCountMatch ? recuCountMatch[1] : '';

      if (this.recuFreq === 'Mensual') {
        const recuDayMatch = haveRecurrence.recurrenceRule.match(/BYMONTHDAY=([^;]*)/);
        this.recuDay = recuDayMatch ? recuDayMatch[1] : '';
      } else if (this.recuFreq === 'Semanal') {
        const recuWeekMatch = haveRecurrence.recurrenceRule.match(/BYDAY=([^;]*)/);
        this.recuWeek = recuWeekMatch ? this.formatWeek(recuWeekMatch[1]) : [];
      }

      const untilMatch = haveRecurrence.recurrenceRule.match(/UNTIL=(\d{8})T(\d{6})Z/);
      if (untilMatch) {
        const untilDateUTC = new Date(Date.UTC(
          parseInt(untilMatch[1].substring(0, 4)),
          parseInt(untilMatch[1].substring(4, 6)) - 1,
          parseInt(untilMatch[1].substring(6, 8)),
          parseInt(untilMatch[2].substring(0, 2)),
          parseInt(untilMatch[2].substring(2, 4)),
          parseInt(untilMatch[2].substring(4, 6))
        ));
        this.untilDate = untilMatch ? this.formatDateFromISO(untilDateUTC) : '';
      } else {
        this.untilDate = "Luego de " + this.recuCount + " visitas"
      }
      this.startDate = this.appoinment?.createdAt ? this.formatDateFromISO(this.appoinment?.createdAt) : '';
    } else {
      this.startDate = this.task.scheduledStart ? this.formatDateFromISO(this.task.scheduledStart) : '';
      this.untilDate = this.task.scheduledEnd ? this.formatDateFromISO(this.task.scheduledEnd) : '';
    }

    this.startDateTime = this.task.scheduledStart ? this.formatDateTimeFromISO(this.task.scheduledStart) : '';

    // if (haveRecurrence) {
    //   const freqMatch = haveRecurrence.recurrenceRule ? haveRecurrence.recurrenceRule.match(/FREQ=([^;]*)/) : null;
    //   this.recuFreq = freqMatch ? this.formatFreq(freqMatch[1]) : '';

    //   const recuIntervalMatch = haveRecurrence.recurrenceRule.match(/INTERVAL=(\d+)/);
    //   this.recuInterval = recuIntervalMatch ? recuIntervalMatch[1] : '';

    //   if (this.recuFreq === 'Mensual') {
    //     const recuDayMatch = haveRecurrence.recurrenceRule.match(/BYMONTHDAY=([^;]*)/);
    //     this.recuDay = recuDayMatch ? recuDayMatch[1] : '';
    //   } else if (this.recuFreq === 'Semanal') {
    //     const recuWeekMatch = haveRecurrence.recurrenceRule.match(/BYDAY=([^;]*)/);
    //     this.recuWeek = recuWeekMatch ? this.formatWeek(recuWeekMatch[1]) : [];
    //   }

    //   const untilMatch = haveRecurrence.recurrenceRule.match(/UNTIL=(\d{8})T/);
    //   this.untilDate = untilMatch ? this.formatDate(untilMatch[1]) : '';

    //   this.startDate = this.appoinment?.createdAt ? this.formatDateFromISO(this.appoinment?.createdAt) : '';
    // } else {
    //   this.startDate = this.task.scheduledStart ? this.formatDateFromISO(this.task.scheduledStart) : '';
    //   this.untilDate = this.task.scheduledEnd ? this.formatDateFromISO(this.task.scheduledEnd) : '';
    // }

    // this.startDateTime = this.task.scheduledStart ? this.formatDateTimeFromISO(this.task.scheduledStart) : '';
    this.dateRange = this.task.scheduledStart ? this.formatDateRange(this.task.scheduledStart, this.task.scheduledEnd) : '';
  }

  formatTime(milliseconds: number): string {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    let formattedTime = '';

    if (hours > 0) {
      formattedTime += `${hours}h `;
    }

    if (minutes > 0) {
      formattedTime += `${minutes}m `;
    }

    if (seconds > 0) {
      formattedTime += `${seconds}s`;
    }

    // Remove trailing space if any
    formattedTime = formattedTime.trim();

    return formattedTime;
  }

  formatFreq(freqString: string): string {
    let frequency: string;
    switch (freqString) {
      case 'DAILY':
        frequency = 'Diaria';
        break;
      case 'WEEKLY':
        frequency = 'Semanal';
        break;
      case 'MONTHLY':
        frequency = 'Mensual';
        break;
      default:
        frequency = 'Otro';
    }
    return frequency;
  }

  formatWeek(dayString: string): string[] {
    const daysArray = dayString.split(',').map(day => Week[day.trim()]);
    daysArray.sort((a, b) => {
      const weekOrder = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
      return weekOrder.indexOf(a) - weekOrder.indexOf(b);
    });

    return daysArray;
  }

  formatDate(dateString: any) {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);

    const monthNames = [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    const monthName = monthNames[parseInt(month, 10) - 1];

    return `${day} de ${monthName}, ${year}`;
  }

  formatDateFromISO(dateString: any) {
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  formatDateTimeFromISO(dateString: any) {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  formatDateRange(dateString1: any, dateString2: any) {
    const date1 = new Date(dateString1);
    const date2 = new Date(dateString2);

    const day1 = date1.getDate();
    const month1 = date1.getMonth() + 1;
    const year1 = date1.getFullYear();
    const hours1 = date1.getHours().toString().padStart(2, '0');
    const minutes1 = date1.getMinutes().toString().padStart(2, '0');

    const day2 = date2.getDate();
    const month2 = date2.getMonth() + 1;
    const year2 = date2.getFullYear();
    const hours2 = date2.getHours().toString().padStart(2, '0');
    const minutes2 = date2.getMinutes().toString().padStart(2, '0');

    if (day1 === day2 && month1 === month2 && year1 === year2) {
      return `${day1}/${month1}/${year1} ${hours1}:${minutes1} - ${hours2}:${minutes2}`;
    } else {
      return `${day1}/${month1}/${year1} ${hours1}:${minutes1} - ${day2}/${month2}/${year2} ${hours2}:${minutes2}`;
    }
  }

  clientsTerm: string = '';
  get f() { return this.form?.controls; }
  async buildForm() {
    let workers = (this.task.workers || []).map(el => el._id);
    let client = _.get(this.task, 'client._id', '');
    const category: any = _.get(this.task, 'category');
    const categoryId = _.isArray(category) ? (category[0] || {})._id : (category || {})._id;
    const scheduledAt = this.task.scheduledAt ? new Date(this.task.scheduledAt).getTime() : '';
    const scheduledStart = this.task.scheduledStart ? this._UtilsService.date.toLocale(this.task.scheduledStart as any) : '';
    const scheduledEnd = this.task.scheduledEnd ? this._UtilsService.date.toLocale(this.task.scheduledEnd as any) : '';
    this.form = this.fb.group({
      title: [this.task.title],
      client: [this.task.client, Validators.compose([Validators.required])],
      description: [this.task.description],
      location: [this.task.location, [Validators.required]],
      latitude: [_.get(this.task, 'coordinates[0]'), [Validators.required]],
      longitude: [_.get(this.task, 'coordinates[1]'), [Validators.required]],
      category: [categoryId, [Validators.required]],
      status: [this.task.status, [Validators.required]],
      workers: [workers],
      newProduct: [null, [productValidator]],
      // otherCharges: [this.task.otherCharges || 0],
      // discount: [this.task.discount || 0, [Validators.min(0)]],
      cost: [this.task.cost || 0],
      subtotal: [this.task.subtotal || 0],
      tax: [this.task.tax || 0],
      taxPercentage: [this.task.taxPercentage || 0],
      total: [this.task.total || 0],

      scheduledAt: [scheduledAt],
      scheduledStart: [scheduledStart],
      scheduledEnd: [scheduledEnd],

      recurringFrequency: [this.recurrence?.recurringFrequency ?? -1],
      recurringInterval: [1],
      recurringWDays: this.fb.array(
        [false, false, false, false, false, false, false].map(val => this.fb.control(val))
      ),
      recurringMDay: [],
      recurringEnd: ['ENDDATE'],
      recurringUntil: [''],
      recurringCount: [1],

      isDeleted: [this.task.isDeleted],
      showStart: [this.showStart],
      showEnd: [this.showEnd],

      quote: [this.task.quote?._id ?? this.task.quote ?? undefined],
      serviceAgreement: [this.task.serviceAgreement?._id ?? this.task.serviceAgreement ?? undefined]
    }, {
      validators: [
      ]
    });


    this.subscriptions.add(this.form.valueChanges.subscribe(async event => await this.onFormValueChange(event)));
  }

  async onFormValueChange(event: any) {
    //console.log(this.constructedForm)
    if (this.constructedForm) {
      this.formValueChanged = true;
    }
  }

  redirectToCalendar() {
    this._router.navigate(['/admin', this._AuthService.companyIndex(), 'calendar']).then(() => {
      window.location.reload();
    });
  }

  openNextAppointmentModal(task: ITask, scheduling: boolean = false, readOnly: boolean = true) {
    let config = new MatDialogConfig();
    config.width = '885px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRefNextAppo = this._dialog.open(NextAppointmentModalComponent, config);
    self.dialogRefNextAppo.componentInstance.task = task;
    self.dialogRefNextAppo.componentInstance.scheduling = scheduling;
    self.dialogRefNextAppo.componentInstance.readOnly = readOnly;

    self.dialogRefNextAppo.afterClosed().subscribe((result: any) => {
      self.dialogRefNextAppo = null;
    });
  }

  async openDuplicateTaskModal(task: ITask, readOnly: boolean = false) {
    task = await lastValueFrom(this._TaskHttpService.getTask(task));

    let message
    if ((this.task.appointment?.schedule as any)?.recurrenceRule) {
      message = "¿Está seguro que desea crear un nuevo trabajo copiando el contenido seleccionado? Las opciones de recurrencias no se duplicarán."
    } else {
      message = "¿Está seguro que desea crear un nuevo trabajo copiando el contenido seleccionado?"
    }

    const modalOptions: IConfirmationDialogOptions = {
      title: "Duplicar Trabajo",
      message: message,
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          let data = _.cloneDeep(task);
          data.status = 'SCHEDULED';

          delete data._id;
          delete data.createdAt;
          delete data.createdBy;
          delete data.scheduledStart;
          delete data.scheduledEnd;
          // console.log(data)

          let config = new MatDialogConfig();
          // config.disableClose = true;
          config.width = '1300px';
          config.maxWidth = '90vw';
          config.viewContainerRef = this._viewContainerRef;
          self.dialogRef = this._dialog.open(TaskModalComponent, config);
          self.dialogRef.componentInstance.task = data;
          // self.dialogRef.componentInstance.readOnly = readOnly;
          self.dialogRef.componentInstance.readOnly = false;
          self.dialogRef.componentInstance.scheduling = true;

          self.dialogRef.afterClosed().subscribe((result: any) => {
            self.dialogRef = null;
            this.dialog.close(this.task);
          });
        }
      });
  }

  productsChanged = false;
  taskModalProductsChange(data: any) {
    this.productsChanged = true;
  }

  taskModalTotalsChange(data: any) {
    this.f['cost'].setValue(data.cost);
    this.f['subtotal'].setValue(data.subtotal);
    this.f['tax'].setValue(data.tax);
    this.f['taxPercentage'].setValue(data.taxPercentage);
    this.f['total'].setValue(data.total);
  }


  private getWeekday(byWeekday: boolean[]): any {
    const result = byWeekday
      .map((v, i) => v && this.weekdayMap[i] || null)
      .filter(v => !!v);
    return result.length ? result : null;
  }

  async onSubmit(newStatus?: string) {
    if (this.productsChanged && this.task.deliverynote) {
      const modalOptions: IConfirmationDialogOptions = {
        title: "Editar trabajo incluido en albarán",
        message: "Si realiza este cambio, se retirará la firma del cliente del albarán.",
        yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
      };
      const confirmation = await this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef).toPromise();
      if (!confirmation) return;
    }

    let user = this._AuthService.profile();

    const newTask: any = _.cloneDeep(this.form.value);
    this.saving = true;
    // validar data presubmit --------------------------------------------------------------------------
    let invalidData = false;
    if (this.task.products?.length === 0) {
      this._AlertService.warn("Trabajos sin conceptos no estan permitidos");
      invalidData = true;
      return
    }
    this.task.products?.map(item => {
      if (item.quantity === 0) {
        this._AlertService.warn("Un concepto no puede tener cantidad 0");
        invalidData = true;
        return
      }
    });
    if (newTask.category === null) {
      this.scrollDialogToTop();
      invalidData = true;
    }
    if (invalidData) {
      this.saving = false;
      return
    };
    // validar data presubmit --------------------------------------------------------------------------

    this.submitted = true;
    if (this.form.invalid) {
      this.saving = false;
      return
    };
    // this.saving = true;
    delete newTask.newProduct;
    newTask.company = this._AuthService.companyId();

    newTask.products = this.task.products?.map(item => {
      return {
        product: item.product?._id,
        name: item.detail || item.name,
        detail: item.detail || item.name || item.product?.name || '',
        description: item.description || this.emptyItem.description,
        quantity: item.quantity || this.emptyItem.quantity,
        unit: item.unit || this.emptyItem.unit,
        price: item.price || this.emptyItem.price,
        cost: item.cost || this.emptyItem.cost,
        subtotal: item.subtotal || this.emptyItem.subtotal,
        taxPercentage: item.taxPercentage || this.task.taxPercentage || this.emptyItem.taxPercentage,
        tax: item.tax || this.emptyItem.tax,
        total: item.total || this.emptyItem.total,
        addBy: item.addBy ?? "admin",
        addByUser: _.get(item, 'addByUser._id') ?? user.id
      }
    });

    // manually 2 way binding
    if (!newTask.status) newTask.status = this.task.status;

    if (newTask.scheduledAt) newTask.scheduledAt = new Date(newTask.scheduledAt).toISOString();
    else delete newTask.scheduledAt;
    if (newTask.scheduledStart) newTask.scheduledStart = new Date(newTask.scheduledStart).toISOString();
    else delete newTask.scheduledStart;
    if (newTask.scheduledEnd) newTask.scheduledEnd = new Date(newTask.scheduledEnd).toISOString();
    else delete newTask.scheduledEnd;

    newTask.coordinates = [newTask.latitude, newTask.longitude];
    delete newTask.latitude;
    delete newTask.longitude;

    delete newTask.showStart;
    delete newTask.showEnd;

    // calcular reglas; --------------------------------------------------------------------------
    // data.recurrence = reglas;

    if (newTask.status == 'SCHEDULED' && (newTask.recurringFrequency >= 0)) {
      //let dateUntil = this._UtilsService.date.localeEndOfDay(startDate);
      //console.log("dateUntil " + this._UtilsService.date.ISOtoLocaleDate(dateUntil));
      const options: Partial<Options> = {
        freq: newTask.recurringFrequency || Frequency.DAILY,
        dtstart: toNativeDate(new Date(newTask.scheduledStart) || new Date()),
        byweekday: newTask.recurringFrequency === Frequency.WEEKLY ? this.getWeekday(newTask.recurringWDays) : null,
        bymonthday: newTask.recurringFrequency === Frequency.MONTHLY ? newTask.recurringMDay : null,
        //until: !data.recurringUntil ? new Date() : new Date(data.recurringUntil),
      };
      if (newTask.recurringInterval > 1) {
        options.interval = newTask.recurringInterval;
      }
      if (newTask.recurringCount > 1) {
        options.count = newTask.recurringCount;
        delete options.until;
      } else {
        console.log(newTask.recurringUntil)
        let dateUntil = this._UtilsService.date.localeEndOfDay(newTask.recurringUntil);
        console.log(dateUntil)
        options.until = new Date(dateUntil);
      }

      const rule = new RRule(options);

      let index = (rule.toString()).lastIndexOf(":");
      const rruleSchedule = (rule.toString()).substring(index + 1);
      if (rule.all().length > 1) {
        this.rruleSchedule = rruleSchedule;
      }

    }
    // fin calcular reglas ------------------------------------------------------------------------

    delete newTask.recurringFrequency;
    delete newTask.recurringInterval;
    delete newTask.recurringWDays;
    delete newTask.recurringMDay;
    delete newTask.recurringEnd;
    delete newTask.recurringUntil;
    delete newTask.recurringCount;

    this.submitted = false;
    this.saving = false;

    if (this.agreementInvoicing && !this.task._id) {
      const newAgreement = {
        company: this._AuthService.companyId(),
        client: newTask.client?._id ?? newTask.client,
        category: newTask.category?._id ?? newTask.category,
        date: new Date(),
        dueDate: new Date(),
        details: _.cloneDeep(newTask.products.map((el: any) => {
          delete el.addBy; delete el.addByUser;
          return el;
        })),
        cost: newTask.cost,
        subtotal: newTask.subtotal,
        // taxPercentage: newTask.taxPercentage,
        tax: newTask.tax,
        total: newTask.total
      } as IServiceAgreement

      newTask.products.map((el: any) => {
        el.price = 0; el.cost = 0; el.subtotal = 0; el.tax = 0; el.taxPercentage = 0; el.total = 0;
        return el;
      });
      newTask.cost = 0; newTask.subtotal = 0; newTask.tax = 0; newTask.taxPercentage = 0; newTask.total = 0;

      const agreement = await lastValueFrom(this._ServiceAgreementHttpService.createAgreement(newAgreement));
      newTask.serviceAgreement = agreement._id;
    }


    if (this.formValueChanged) {

      this.refreshPage = true

      if (this.productsChanged && this.task.deliverynote && this.task.deliverynote.signature) {
        newTask.removeSignature = true;
      }

      if (this.appoinment != null) {
        if (this.haveRecurrence != null) {
          newStatus !== 'COMPLETED' && newStatus !== 'INVOICED' ? this.saveMany(newTask) : this.save(newTask);
        } else {
          newStatus !== 'COMPLETED' && newStatus !== 'INVOICED' ? this.save(newTask, newStatus) : this.save(newTask);
        }
      } else {
        this.save(newTask, newStatus)
      }
    } else {
      this.submitted = false;
      this.saving = false;
      if (newStatus) this.getTask(newStatus);
    }
  }

  save(data: any, newStatus?: string) {
    data.client = data.client._id;
    if (this.rruleSchedule != undefined) {
      data.recurrenceRule = this.rruleSchedule;
    }
    if (this.task._id) {
      data._id = this.task._id;
      data.appointmentId = this.appoinment._id;
      this._TaskHttpService.updateTask(data).subscribe((task: any) => {
        this._broadcaster.broadcast('OnTaskChange', true);
        if (this.scheduling && !newStatus) {
          this._AlertService.success('Se ha programado el trabajo en su Agenda y el personal asignado ha sido notificado de sus detalles');
          return this.dialog.close(task);
        }
        this.submitted = false;
        this.saving = false;
        this.task = task;
        this.getTask(newStatus);
      });
    } else {
      this._TaskHttpService.createTask(data).subscribe((task: any) => {
        this._broadcaster.broadcast('OnTaskChange', true);
        if (this.scheduling && !newStatus) {
          this._AlertService.success('Se ha programado el trabajo en su Agenda y el personal asignado ha sido notificado de sus detalles');
          return this.dialog.close(task);
        }
        this.submitted = false;
        this.saving = false;
        this.task = task;
        this.getTask(newStatus);
      });
    }
  }

  saveMany(data: any, newStatus?: string) {
    const modalOptions: ICustomDialogOptions = {
      title: " ¿Qué cita(s) desea actualizar?",
      message: "Atención: los cambios de fecha se aplicarán solo a este trabajo",
      showYesAll: this.appoinment['schedule'] != null ? true : false,
      colorYesAllButton: "#a89532",
      yesAllButtonLabel: 'Esta cita y las siguientes', yesButtonLabel: 'Solo esta cita', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openCustomModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        data._id = this.task._id;
        data.client = data.client._id;
        data.appointmentId = this.appoinment._id;
        if (confirmation === true) {
          this._TaskHttpService.updateTask(data).subscribe((task: any) => {
            this._broadcaster.broadcast('OnTaskChange', true);
            if (this.scheduling && !newStatus) {
              this._AlertService.success('Se ha programado el trabajo en su Agenda y el personal asignado ha sido notificado de sus detalles');
              return this.dialog.close(task);
            }
            this.submitted = false;
            this.saving = false;
            this.task = task;
            this.getTask(newStatus);
          });
        } else {
          this.saving = false;
        }
        if (confirmation == 3) {
          data.updateMany = true;
          this._TaskHttpService.updateTask(data).subscribe((task: any) => {
            this._broadcaster.broadcast('OnTaskChange', true);
            if (this.scheduling && !newStatus) {
              this._AlertService.success('Se ha programado el trabajo en su Agenda y el personal asignado ha sido notificado de sus detalles');
              return this.dialog.close(task);
            }
            this.submitted = false;
            this.saving = false;
            this.task = task;
            this.getTask(newStatus);
          });
        }
      });
  }

  /*----------------- Modals Task Single ------------------*/

  confirmExit() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Salir",
      message: "¿Está seguro de que desea salir? Los cambios no se guardarán",
      yesButtonLabel: 'Sí, deseo salir',
      noButtonLabel: 'Cancelar'
    };

    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: boolean) => {
        if (confirmation) {
          self.dialogRef.close();
        }
      });
  }

  closeModal() {
    // if (!this.readOnly && this.formValueChanged) {
    //   this.confirmExit()
    // } else {
    if (this.refreshPage) {
      self.dialogRef.close(this.task);
    } else {
      self.dialogRef.close();
    }
    //}
  }

  cancelSubmit() {
    if (!this.task._id) return this.dialog.close();
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.getTask();
  }

  openEditTaskModal(task: ITask, scheduling: boolean = false, readOnly: boolean = true) {
    let config = new MatDialogConfig();
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.hasBackdrop = true;
    config.disableClose = true;
    config.viewContainerRef = this._viewContainerRef;
    self.editTaskDialogRef = this._dialog.open(TaskModalComponent, config);
    self.editTaskDialogRef.componentInstance.task = task;
    self.editTaskDialogRef.componentInstance.scheduling = scheduling;
    self.editTaskDialogRef.componentInstance.readOnly = false;

    self.editTaskDialogRef.afterClosed().subscribe((result: any) => {
      self.editTaskDialogRef = null
      if (result) this.refreshPage = true;
      if (result) this.getTask();
    });
  }

  openDeleteTaskConfirm() {
    const modalOptions: IConfirmationDialogOptions = {
      title: "Eliminar Trabajo",
      message: "Esta seguro que desea eliminar este Trabajo?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this._TaskHttpService.deleteTask(this.task).subscribe(() => {
            this._broadcaster.broadcast('OnTaskChange', true);
            //this.setEditable(false);
            this.dialog.close(this.task);
            window.location.reload()
            //this.getTask();
          })
        }
      });
  }

  openUnderConstructionDialog() {
    const modalOptions: IInformationDialogOptions = {
      title: "¡Próximamente!",
      message: "Esta funcionalidad se encuentra en construcción.",
      closeButtonLabel: "Ok"
    };
    this._dialogService.openInformationModal(modalOptions, this._viewContainerRef)
      .subscribe(() => {
        console.log('ok')
      });
  }

  /*----------------- Delivery note ------------------*/
  createDeliveryNote() {
    const note = {
      company: this._AuthService.companyId(),
      client: this.task.client?._id,
      description: this.task.description,
      tasks: [this.task._id]
    };
    this._DeliveryNotesService.createDeliveryNote(note).subscribe(note => {
      this._broadcaster.broadcast('OnDeliveryNoteChange', note);
      this.submitted = false;
      this.saving = false;
      this.scheduling = false;
      this.getTask();
    })
  }

  openDeliveryNote() {
    if (this.task.deliverynote) {
      this.openDeliveryNotePDF(this.task.deliverynote);
    } else {
      const modalOptions: IConfirmationDialogOptions = {
        title: "Generar Albarán",
        message: "¿Desea generar el albarán para este trabajo?\nLuego podra compartirlo con el cliente para su firma de conformidad.",
        yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
      };
      this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef).subscribe((confirmation: any) => {
        if (confirmation) {
          this.createDeliveryNote();
        }
      });
    }
  }

  openDeliveryNotePDF(deliverynote: any) {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dn_pdfDialogRef = this._dialog.open(DeliveryNotesPDFModalComponent, config);
    self.dn_pdfDialogRef.componentInstance.document = deliverynote;

    self.dn_pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.dn_pdfDialogRef = null;
    });
  }

  /*----------------- Billing doc ------------------*/
  invoiceTask() {
    if (this.f['total'].value <= 0) {
      return this._AlertService.warn("El importe Total no puede ser cero");
    }

    if (this.form.invalid) {
      this.submitted = true;
      this.form.markAllAsTouched();
      return this._AlertService.warn("Formulario incorrecto");
    };

    const modalOptions: IConfirmationDialogOptions = {
      title: "Facturar",
      message: "Esta seguro que desea Facturar este Trabajo?",
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef).subscribe((confirmation: any) => {
      if (confirmation) {
        let config = new MatDialogConfig();
        config.width = '1200px';
        config.maxWidth = '90vw';
        config.viewContainerRef = this._viewContainerRef;
        self.dialogRefInvoice = this._dialog.open(BillingDocumentsModalComponent, config);
        console.log(this.task)
        self.dialogRefInvoice.componentInstance.tasks = [this.task];
        self.dialogRefInvoice.componentInstance.document = {
          type: IBillingDocumentTypes.INVOICE,
          client: this.task.client
        };
        self.dialogRefInvoice.componentInstance.readOnly = false;
        self.dialogRefInvoice.componentInstance.editting = true;
        self.dialogRefInvoice.componentInstance.redirectToBill = true;

        self.dialogRefInvoice.afterClosed().subscribe((result: any) => {
          this.submitted = false;
          this.saving = false;
          this.scheduling = false;
          this.getTask();
        });
      }
    });
  }

  openInvoice() {
    let config = new MatDialogConfig();
    config.width = '1200px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.pdfDialogRef = this._dialog.open(BillingDocumentsPDFModalComponent, config);
    self.pdfDialogRef.componentInstance.document = this.invoice;

    self.pdfDialogRef.afterClosed().subscribe((result: any) => {
      self.pdfDialogRef = null;
    });
  }


  /*----------------- Comment ------------------*/
  openNewCommentModal() {
    let config = new MatDialogConfig();
    config.width = '900px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.commentDialogRef = this._dialog.open(TaskCommentComponent, config);
    self.commentDialogRef.componentInstance.task = this.task;

    self.commentDialogRef.afterClosed().subscribe((result: any) => {
      self.commentDialogRef = null;
      if (result) this.getComments();
    });
  }

  openFile(file: IFile) {
    if (!file._id) return;
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.fileDialogRef = this._dialog.open(FileViewModalComponent, config);
    self.fileDialogRef.componentInstance.file = file;

    self.fileDialogRef.afterClosed().subscribe((result: any) => {
      self.fileDialogRef = null;
    });
  }

  openPdf(file: IFile) {
    if (!file._id) return;
    window.open(file.fileUrl, "_blank");
  }

  /*----------------- Report ------------------*/
  openMovementsModal() {
    let config = new MatDialogConfig();
    config.width = '1700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.movementsDialogRef = this._dialog.open(TaskMovementsComponent, config);
    self.movementsDialogRef.componentInstance.task = this.task;

    self.movementsDialogRef.afterClosed().subscribe((result: any) => {
      self.movementsDialogRef = null;
    });
  }

  /*----------------- Share module ------------------*/
  openShareModal() {
    if (this.task._id) {
      if ((this.task?.status == 'QUOTED' || this.task.status == 'INVOICED')) {
        this.openSharedModal();
      } else {
        this.openExternalRequestModal()
      }
    }
  }

  openExternalRequestModal() {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.shareDialogRef = this._dialog.open(ExternalRequestModalComponent, config);
    self.shareDialogRef.componentInstance.task = this.task;

    self.shareDialogRef.afterClosed().subscribe((result: any) => {
      self.shareDialogRef = null;
    });
  }

  openSharedModal() {
    let config = new MatDialogConfig();
    config.width = '800px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.shareDialogRef = this._dialog.open(TaskShareComponent, config);
    self.shareDialogRef.componentInstance.task = this.task;
    self.shareDialogRef.componentInstance.showWhatsapp = (this.f['client'].value?.phones?.length > 0);
    self.shareDialogRef.componentInstance.showEmail = (this.f['client'].value?.email?.length > 0);
    self.shareDialogRef.afterClosed().subscribe((result: any) => {
      self.shareDialogRef = null;
    });
  }


  /*----------------- Detail ------------------*/
  onListChange(event: any) {
    // console.log(event);
    // this.f.details.setValue(event.items);
    this.f['cost'].setValue(event.totals.cost );
    this.f['subtotal'].setValue(event.totals.subtotal);
    this.f['tax'].setValue(event.totals.tax);
    this.f['total'].setValue(event.totals.total);
  }

  setInvoicingAgreement(aggrement: boolean) {
    this.agreementInvoicing = aggrement;
  }

  formatPercentage(task: any): string {
    const total = task.total || 0;
    const cost = task.cost || 0;
    const totalExpenses = task.totalExpenses || 0;
  
    if (total === 0) {
      return '0%';
    }
  
    const profitability = ((total - cost - totalExpenses) / total) * 100;
    return profitability.toFixed(2).replace('.', ',') + '%';
  }  
}

function productValidator(control: AbstractControl): any {
  if (control.value && !_.get(control.value, '_id')) {
    return { notFound: true };
  }
}

function getValue(key: any, str: any) {
  const regex = new RegExp(`${key}=([^;]+)`);
  const match = str.match(regex);
  return match ? match[1] : null;
}